/**
 * A project's links as its form checks them (2026-10-26) — the API's rules in
 * `apps/backend/src/domain/project-links.ts`, so a row it would refuse is
 * pointed out on the row before anything is sent.
 */

export interface ProjectLink {
  name: string;
  url: string;
}

export const MAX_LINK_NAME_LENGTH = 80;
export const MAX_LINK_URL_LENGTH = 2048;

export type LinkUrlProblem = 'required' | 'invalid' | 'password';

/** What is wrong with an address as typed, or null. Typed without a scheme, it is taken as https. */
export function linkUrlProblem(input: string): LinkUrlProblem | null {
  let text = input.trim();
  if (!text) return 'required';
  if (!/^[a-z][a-z0-9+.-]*:\/\//i.test(text)) text = `https://${text}`;
  if (text.length > MAX_LINK_URL_LENGTH || /[\s\u0000-\u001f\u007f-\u009f᠎]/.test(text)) return 'invalid';
  let parsed: URL;
  try {
    parsed = new URL(text);
  } catch {
    return 'invalid';
  }
  if ((parsed.protocol !== 'https:' && parsed.protocol !== 'http:') || !parsed.hostname) return 'invalid';
  if (parsed.username || parsed.password) return 'password';
  return null;
}

/** The rows as they are sent: trimmed, and a wholly blank one left out. */
export function cleanLinks(rows: ReadonlyArray<ProjectLink>): ProjectLink[] {
  return rows.map((row) => ({ name: row.name.trim(), url: row.url.trim() })).filter((row) => row.name || row.url);
}
